import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import IssueRequest from "../../magData/Hotel/IssueRequest";
import IssueResponse from "../../magData/Hotel/IssueResponse";

function HotelIssuePage(props) {

  return (
    <>

      <Container fluid >
        <Row>
          <Col sm={12} >
            <p className="page-title">Hotel Issue Method</p>
          </Col>
          <Col sm={12} >
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/Hotel/issue</p>
          </Col>
          <Col sm={12} >
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12} >
            <p>Body Parameters</p>
          </Col>
          <Col sm={12}>
            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>gdsRefrenceID</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Request Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(IssueRequest, null, 2)}
            </pre>
          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12} >
            <p>Response Information</p>
          </Col>
          <Col sm={12}>
            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>gdsRefrenceID</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Response Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(IssueResponse, null, 2)}
            </pre>


          </Col>
        </Row>
      </Container>

    </>
  );
}

export default HotelIssuePage;